import React from 'react';
import styles from './StepBar.module.css';

const STEPS = ['Dados', 'Endereço', 'Resultado'];

export default function StepBar({ current }) {
  // No passo 3 (resultado), tudo fica verde
  const allDone = current === 3;

  return (
      <div className={styles.bar} role="progressbar" aria-valuenow={current} aria-valuemin={1} aria-valuemax={3}>
        {STEPS.map((label, i) => {
          const step    = i + 1;
          const isDone   = allDone || step < current;
          const isActive = !allDone && step === current;

          return (
              <React.Fragment key={label}>
                <div className={styles.item}>
                  <div className={[
                    styles.dot,
                    isDone   ? styles.done   : '',
                    isActive ? styles.active : '',
                  ].join(' ')}>
                    {isDone ? (
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                          <path d="M2 6l3 3 5-5" stroke="white" strokeWidth="2"
                                strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    ) : step}
                  </div>
                  <span className={[
                    styles.label,
                    isDone   ? styles.labelDone   : '',
                    isActive ? styles.labelActive : '',
                  ].join(' ')}>
                {label}
              </span>
                </div>

                {i < STEPS.length - 1 && (
                    <div className={[styles.line, isDone ? styles.lineDone : ''].join(' ')} />
                )}
              </React.Fragment>
          );
        })}
      </div>
  );
}